var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3181_7159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.5C3.75 23.1875 4.3125 23.75 5 23.75H11.25V21.25H5C4.3125 21.25 3.75 21.8125 3.75 22.5ZM3.75 7.5C3.75 8.1875 4.3125 8.75 5 8.75H16.25V6.25H5C4.3125 6.25 3.75 6.8125 3.75 7.5ZM16.25 25V23.75H25C25.6875 23.75 26.25 23.1875 26.25 22.5C26.25 21.8125 25.6875 21.25 25 21.25H16.25V20C16.25 19.3125 15.6875 18.75 15 18.75C14.3125 18.75 13.75 19.3125 13.75 20V25C13.75 25.6875 14.3125 26.25 15 26.25C15.6875 26.25 16.25 25.6875 16.25 25ZM8.75 12.5V13.75H5C4.3125 13.75 3.75 14.3125 3.75 15C3.75 15.6875 4.3125 16.25 5 16.25H8.75V17.5C8.75 18.1875 9.3125 18.75 10 18.75C10.6875 18.75 11.25 18.1875 11.25 17.5V12.5C11.25 11.8125 10.6875 11.25 10 11.25C9.3125 11.25 8.75 11.8125 8.75 12.5ZM26.25 15C26.25 14.3125 25.6875 13.75 25 13.75H13.75V16.25H25C25.6875 16.25 26.25 15.6875 26.25 15ZM20 11.25C20.6875 11.25 21.25 10.6875 21.25 10V8.75H25C25.6875 8.75 26.25 8.1875 26.25 7.5C26.25 6.8125 25.6875 6.25 25 6.25H21.25V5C21.25 4.3125 20.6875 3.75 20 3.75C19.3125 3.75 18.75 4.3125 18.75 5V10C18.75 10.6875 19.3125 11.25 20 11.25Z",
    fill: "#2396DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3181_7159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.b9a748eda5711f432923a2b2068852b5.svg";
export { ForwardRef as ReactComponent };